import React from 'react';

const FieldContext = React.createContext({ user: {} });

export default FieldContext;
